export { PrivateCompanyTile, type PrivateCompanyTileProps } from './PrivateCompanyTile';
